import { render, staticRenderFns } from "./ProductAvailability.vue?vue&type=template&id=10be01bb&"
import script from "./ProductAvailability.vue?vue&type=script&lang=js&"
export * from "./ProductAvailability.vue?vue&type=script&lang=js&"
import style0 from "./ProductAvailability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports